import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export function useCreateAccountPhoneSchema(countryCode: CountryCode | undefined, isPasswordRequired: boolean) {
  const { t } = useTranslation()

  return useMemo(
    () =>
      yup.object({
        phone: yup
          .string()
          .test('Valid Phone', t('screens.welcome.form.phone.validNumber'), function (value) {
            return isValidPhoneNumber(value || '', countryCode)
          })
          .required(t('screens.welcome.form.phone.required')),
        password: yup.string().when([], {
          is: () => isPasswordRequired,
          then: yup.string().required(t('screens.createAccountProfile.password.required')),
          otherwise: yup.string().notRequired(),
        }),
      }),
    [t, countryCode, isPasswordRequired]
  )
}
